<template>
  <div class="row">
    <div class="col-4 col-md-3 mb-4" v-for="imageId in images" :key="imageId">
      <img class="rounded" width="100%" :src="`https://ucarecdn.com/${ imageId }/-/scale_crop/300x300/center/-/quality/lighter/`">
    </div>
    <div class="col-4 col-md-3 mb-4">
      <app-placeholder-square :refresh="false" @upload="onUpload"/>
    </div>
  </div>
</template>

<script>
import AppPlaceholderSquare from '@/components/App/AppPlaceholderSquare'

export default {
  components: {
    AppPlaceholderSquare,
  },

  props: {
    variant: Object,
  },

  data() {
    return {
      images: this.variant.images,
    }
  },

  methods: {
    async onUpload(imageId) {
      try {
        var { data } = await this.$http.put(`/product-variants/${ this.variant.id }/images`, {
          image_id: imageId,
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      }

      this.images.push(imageId)
      this.$message.success(data.message)
    },
  },
}
</script>

<style>

</style>
